export const stringIsEmpty = (str) => {
  const empty = new RegExp(/^\s*$/);
  return (!str || empty.test(str));
};
